import { useContext, useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { APIContext } from "../../../Contexts/APIContext";
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, Tooltip, Title } from "chart.js";

ChartJS.register(
    Title,
    Tooltip
    );

interface ChartData {
    label: string;
    value: number;
    percentage: number;
}

interface IProps {
    onClose: () => void;
    open: boolean;
    surveyId: string;
    date: string;
}

export default function OccupancyChart({ open, onClose, surveyId, date }: IProps) {
    const { post } = useContext(APIContext);
    const [data, setData] = useState<ChartData[]>([]);

    useEffect(() => {
        if (open) {
            getData();
        }
    }, [open]);

    const getData = () => {
        const vm = {
            surveyId: surveyId,
            date: date
        }
        post("Chart", `GetOccupancyForSurvey`, vm, setData);
    }
    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: true,
                text: 'Occupancy Split Chart',
                font: {
                    size: 14,
                    weight: 'bold' as const,
                },
                padding: 20
            },
            tooltip: {
                displayColors: false,
                callbacks: {
                    title: () => '',
                    label: (context: any) => {
                        const dataIndex = context.dataIndex;
                        const item = data[dataIndex];

                        return [
                            `Vehicle Count: ${item.value || 0}`,
                            `Percentage: ${item.percentage.toFixed(2) || 0}`,
                        ];
                    },
                },
            },
        },
        scales: {
            y: {
                title: {
                    display: true,
                    font: {
                        size: 12,
                        weight: 'bold' as const,
                    },
                    text: 'Total Vehicles'
                }
            },
            x: {
                title: {
                    display: true,
                    font: {
                        size: 12,
                        weight: 'bold' as const,
                    },
                    text: 'Number of Occupants'
                }
            }
        }
    }
    const chartData = {
        labels: data.map((m) => m.label),        
        datasets: [
            {
                label: 'Occupancy',
                data: data.map((d) => d.value),
                dataLabels: data.map((d) => d.percentage.toFixed(2) + "%"),
                backgroundColor: [
                    "rgba(255, 99, 132, 0.6)",
                    "rgba(54, 162, 235, 0.6)",
                    "rgba(255, 206, 86, 0.6)",
                    "rgba(75, 192, 192, 0.6)",
                    "rgba(153, 102, 255, 0.6)",
                    "rgba(255, 159, 64, 0.6)",
                    "rgba(100, 100, 100, 0.6)",
                ],
                borderColor: [
                    "rgba(255, 99, 132, 1)",
                    "rgba(54, 162, 235, 1)",
                    "rgba(255, 206, 86, 1)",
                    "rgba(75, 192, 192, 1)",
                    "rgba(153, 102, 255, 1)",
                    "rgba(255, 159, 64, 1)",
                    "rgba(100, 100, 100, 1)",
                ],
                borderWidth: 1,
            },
        ],
    };

    return (
        <Dialog open={open} fullWidth maxWidth="sm" onClose={onClose}>
            <div style={{ padding: "10px" }}>
                <Bar data={chartData} options={options} />
            </div>
        </Dialog>
    );
}